import { WarningCircle } from 'iconoir-react'
import { ReactElement, useState } from 'react'
import Spinner from 'app/components/Spinner'
import type { ContactJson } from 'app/types/entities'
import { notifyError, notifySuccess } from 'app/services/notify.client'
import { useContactStore } from 'app/stores/StoreContext'
import { debug, logError } from 'lib/logging'

export function RevertNonPatient({
  contact,
  onChange,
}: {
  contact: ContactJson
  onChange: (contact: ContactJson) => void
}): ReactElement {
  const contactStore = useContactStore()
  const [saving, setSaving] = useState<boolean>(false)
  const handleRevertMarkNonPatient = async () => {
    setSaving(true)
    try {
      const updateResult = await contactStore.update(contact.id!, { patientStatus: `Active` })
      debug(`contacts`, `update patient status`, updateResult)
      if (updateResult.error) {
        logError(`revert mark non patient failed - patientStatus`, updateResult.error.message)
        notifyError(`There was an error updating the contact`)
        return
      }
      const rebuildResult = await contactStore.recalculateContact(contact.id!)
      debug(`contacts`, `revert mark non patient rebuild`, rebuildResult)
      if (rebuildResult.error) {
        logError(`revert mark non patient - rebuild`, rebuildResult.error.message)
        notifyError(`There was an error rebuilding the contact`)
        await contactStore.update(contact.id!, { patientStatus: `NonPatient` })
        return
      }
      const response = (rebuildResult.data as any)?.recalculateContact as ContactJson | undefined
      notifySuccess(`Revert Non Patient Completed`)
      onChange({ ...(response ?? contact), patientStatus: `Active` } as ContactJson)
    } catch (err) {
      logError(`rebuild failed`, err)
      notifyError(`There was an error marking a contact as patient`)
    } finally {
      setSaving(false)
    }
  }
  return (
    <div className="mx-4 mt-4 flex items-center gap-x-2 rounded-lg border border-dashed border-red-800 bg-red-300 p-4 align-top">
      <WarningCircle className="text-default" />

      <span className="text-left text-body-xs text-default">
        This contact has been marked as a non-patient.{` `}
        <button
          disabled={saving}
          className="text-ui-xs text-blue-600 focus-visible:outline-none"
          onClick={handleRevertMarkNonPatient}
        >
          {saving ? (
            <div className="flex gap-x-1">
              <Spinner className="fill-trn-600" />
              <span>Rebuild in process...</span>
            </div>
          ) : (
            `Revert`
          )}
        </button>
      </span>
    </div>
  )
}
